export const language = {
  en: {
    'Product Type': 'Product Type',
    'Base': 'Base',
    'Import': 'Import',
    'Ships From': 'Ships From',
    'Category': 'Category',
    'All Category': '< All Category',
  },
  zh: {
    'Product Type': '商品类型',
    'Base': '基地商品',
    'Import': '进口商品',
    'Ships From': '发货国家',
    'Category': '商品分类',
    'All Category': '< 全部分类',
  }
};